import 'whatwg-fetch';


export const downloadParticipants = () => (
  (dispatch) => {
    fetch('/api/participants1.json?approved=true')
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          let participants = {
            byLastName: {},
            byEducation: {},
            counts: {
              all: 0
            },
            sections: json.eventBranchViews
          };

          json.eventBranchViews.forEach(section => {
            participants.counts[section.id] = 0;
          });

          json.participantViewList.forEach(participant => {
            if (participant.eventBranchIds.length !== 0) {

              const literal = participant.userShortView.lastName
                .charAt(0)
                .toUpperCase();
              if (!participants.byLastName[literal]) {
                participants.byLastName[literal] = [];
              }

              let participantData = {
                firstName: participant.userShortView.firstName,
                lastName: participant.userShortView.lastName,
                idStr: participant.idStr,
                sections: participant.eventBranchIds
              };
              let cropEducation, studyPlace;
              if (participant.schoolProfileView) {
                participantData.education =
                  `${participant.schoolProfileView.schoolView.name}, ${participant.schoolProfileView.grade} класс`;
                cropEducation = `${participant.schoolProfileView.grade} класс`;

                studyPlace = participant.schoolProfileView.schoolView.name;
                if (!participants.byEducation[studyPlace]) {
                  participants.byEducation[studyPlace] = []
                }
              } else {
                participantData.education =
                  `${participant.studentProfileView.instituteView.name}, ${participant.studentProfileView.department}, ${participant.studentProfileView.course} курс`;
                cropEducation = `${participant.studentProfileView.department}, ${participant.studentProfileView.course} курс`;

                studyPlace = participant.studentProfileView.instituteView.name;
                if (!participants.byEducation[studyPlace]) {
                  participants.byEducation[studyPlace] = []
                }
              }

              participant.eventBranchIds.forEach(section => {
                participants.counts[section]++;
              });

              participants.byLastName[literal].push({...participantData});
              participantData.education = cropEducation;

              participants.byEducation[studyPlace].push(participantData);
              participants.counts.all++;
            }
          });

          dispatch({
            type: 'PARSE_PARTICIPANTS_LIST',
            participants: participants
          });
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'PARTICIPANTS_ERROR',
          error: err,
        })
      })
  }
);

export const checkoutFilter = () => (
  (dispatch) => {
    dispatch({ type: 'CHECKOUT_FILTER' })
  }
);



// WEBPACK FOOTER //
// ./src/participants-page/actions.js